export default __webpack_public_path__ + "f39349e48d0be1b923ee23deb250ed3d.png";